import { createClient } from '@supabase/supabase-js';

import { environment } from '@env';

const { supabaseUrl, supabaseAnonKey } = environment;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
